<template>
    <toast :pt="pt">
        <template #container="{message, closeCallback}">
            <toast-container :close-callback="closeCallback" :message="message" />
        </template>
    </toast>
</template>

<script setup>
import Toast from 'primevue/toast';
import ToastContainer from './ToastContainer.vue';

const pt = {
    root: ({props}) => ({
        class: [
            // Topmost layer, above dialog masks (z-10050) and date picker panels (z-10060).
            'inset-x-[20px] sm:inset-auto sm:w-96 rounded-md mt-[35px] z-10070!',
            {
                '-translate-x-2/4':
                    props.position === 'top-center' || props.position === 'bottom-center',
            },
        ],
    }),
    transition: {
        enterFromClass: 'opacity-0 translate-y-2/4',
        enterActiveClass: 'transition-[transform,opacity] duration-300',
        leaveFromClass: 'max-h-[1000px]',
        leaveActiveClass:
            'transition-[max-height_.45s_cubic-bezier(0,1,0,1),opacity_.3s,margin-bottom_.3s]! overflow-hidden',
        leaveToClass: 'max-h-0 opacity-0 mb-0',
    },
};
</script>
